<template>
    <!--
      组件用途：排行榜单项，展示排名、头像、名称、指标与金额。
      结构划分：
      - 左侧排名：本人显示“我”，前3名显示奖杯图，其他显示数字排名。
      - 中间信息：头像 + 名称；根据 status 切换主/副标题显示。
      - 右侧指标：根据 status/statusTab 切换字段与单位（w 或 %）。
      - 金额展示：status 为 3 时有特殊分支（百万大咖夺金奖显示档位）。
    -->
    <div class="ranking-list-item" :class="{ me: isMe }">
        <div class="ranking-num" v-if="isMe">
            <!-- 本人排名特殊样式，红色数字突出显示 -->
            <p>我</p>
            <p class="color-red">{{ item.rnk }}</p>
        </div>
        <div class="ranking-num" v-else>
            <!-- 非本人：前3名显示奖杯图，其余显示数字排名 -->
            <p v-if="index > 3">{{ index }}</p>
            <img v-else :src="`https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-02-18/top${index}.png`" alt="">
        </div>
        <div class="ranking-name">
            <van-image class="img" round :src="item.avatar" error-icon="" />
            <!-- 名称展示：status === '2' 仅显示门店名，其余显示主/副标题 -->
            <div class="ellipsis" v-if="status === '2'">{{ item.storeName }}</div>
            <div v-else class="ellipsis">
                <!-- 主标题：status === '1' 显示服务员工名，否则显示员工名 -->
                <div v-if="status === '1'">{{ item.serviceEmpName }}</div>
                <div v-else>{{ item.employeeName }}</div>
                <!-- 副标题：非 '5' 显示门店名，'5' 显示区域名 -->
                <div class="ellipsis store-name" v-if="status !== '5'">{{ item.storeName }}</div>
                <div class="ellipsis store-name" v-if="status === '5'">{{ item.areaName }}</div>
            </div>
        </div>
        <div class="ranking-order" v-if="status === '2'">
            <!-- 指标值：字段通过 getTheme('order') 动态映射；单位随 status 切换 -->
            {{ item.custflowBfNetBcF0Mtd }}
        </div>
        <div class="ranking-order" :class="{ 'ranking-orderT': status !== '2' }">
            <!-- 指标值：字段通过 getTheme('order') 动态映射；单位随 status 切换 -->
            {{ item[getTheme('order')] }}
            <span v-if="status !== '2'">w</span>
            <span v-if="status === '2'">%</span>
        </div>
        <div class="ranking-order" v-if="currentGroupMillionTab === '自我突破奖(百万)'">{{ item.saleAmtBfSelfBcYoy }}%</div>
        <!-- 金额/档位展示：status === '3' 且百万大咖榜单时显示 gearPosition，否则显示金额 -->
        <div class="ranking-order" v-if="status !== '3'">{{ item[getTheme('orderAmt')] || 0 }}元</div>
        <div class="ranking-order" v-else>
            <span v-if="currentGroupMillionTab == '百万大咖夺金奖'">{{ item.gearPosition }}</span>
            <span v-else>{{ item[getTheme('orderAmt')] || 0 }}元</span>
        </div>
        <!-- <div class="ranking-bonus">{{ item.awardAmt }}元</div> -->
    </div>
</template>

<script>
    export default {
        name: 'RankingItem',
        props: {
            // 单条排行数据对象（后端返回），包含头像、名称、指标、金额等字段
            item: {
                type: Object,
                default: () => { }
            },
            // 是否为“我”的榜单项，控制左侧排名展示为“我”
            isMe: {
                type: Boolean,
                default: false
            },
            // 排名序号（用于前3名展示奖杯图）
            index: {
                type: Number,
                default: 0
            },
            // 展示维度状态：
            // '1' 服务员工维度、'2' 门店维度、'5' 区域维度（其他值视为员工维度）
            status: {
                type: String,
                default: '1'
            },
            // 特殊分组标签：当为“第5组”时，部分指标字段（custflowYoy）切换为 custflowTargetPer
            statusTab: {
                type: String,
                default: '1'
            },
            // 百万大咖榜单标签：当为“百万大咖夺金奖”且 status === '3' 时，金额展示用档位（gearPosition）
            currentGroupMillionTab: {
                type: String,
                default: false
            }
        },
        data() {
            return {

            }
        },
        methods: {
            // 字段映射工具：根据当前 status/statusTab 返回对应的字段名
            // type 可为：'order'（指标字段）、'orderAmt'（金额字段）、'cardBgColor'（背景色）
            getTheme(type) {
                const index = this.status * 1 - 1
                const theme = {
                    cardBgColor: ['#FDE3D7', '#FDE3D7', '#F1DEA9', '#F6F2FF', '#F6F2FF'],
                    // 指标对应字段（随 status 切换）
                    order: ['netAmtBfBcBody', 'custflowYoy', 'saleAmtBfSelfBc', 'accountAmtMtd', 'accountAmtMtd'],
                    // 金额对应字段（随 status 切换）
                    orderAmt: ['awardAmt', 'awardAmt', 'award', 'awardAmt', 'awardAmt'],
                }
                // if (this.statusTab == '第5组') {
                //     // 第5组特殊：客流同比改用目标达成率
                //     theme.order[1] = 'custflowTargetPer'
                // }
                return theme[type][index];
            }
        }
    }
</script>

<style lang='less' scoped>

    /* 单行条目容器：包含排名、名称、指标与金额四部分 */
    .ranking-list-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        // margin: 10px 0;
        padding: 30px 40px;
        border-bottom: 2px solid #eeeeee;

        &.me {
            /* 本人项高亮背景与圆角 */
            padding: 20px;
            margin-top: 30px;
            background-color: #FDE3D7;
            border-radius: 12px;
            border: none;
        }

        &.title {
            padding-bottom: 0;
            border: none;
            color: #999999;
        }

        // &:nth-last-child(1) {
        //     border: none;
        // }

        /* 左侧排名区域 */
        .ranking-num {
            width: 60px;
            margin-right: 30px;

            .color-red {
                color: #AB080B;
            }

            p {
                margin: 0;
                text-align: center;
            }

            >img {
                width: 50px;
                height: 60px;
            }
        }

        /* 中间头像与名称区域 */
        .ranking-name {
            display: flex;
            align-items: center;
            width: 240px;

            div {
                width: 100%;
            }

            >.img {
                width: 60px;
                height: 60px;
                min-width: 60px;
                margin-right: 10px;
            }

            .store-name {
                font-size: 22px;
            }

        }

        /* 右侧指标与金额区域 */
        .ranking-order {
            width: 110px;
            text-align: center;
        }

        .ranking-orderT {
            width: 140px;
            text-align: center;
        }

        .ranking-bonus {
            width: 180px;
            text-align: center;
        }
    }
</style>